import { render, staticRenderFns } from "./AcaoObjetoHistoricoTab.vue?vue&type=template&id=e2394b8a&scoped=true"
import script from "./AcaoObjetoHistoricoTab.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoHistoricoTab.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoHistoricoTab.vue?vue&type=style&index=0&id=e2394b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2394b8a",
  null
  
)

export default component.exports